/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type VisitTakenPayloadSideEffectType =
  (typeof VisitTakenPayloadSideEffectType)[keyof typeof VisitTakenPayloadSideEffectType];

export const VisitTakenPayloadSideEffectType = {
  visit_taken: "visit_taken",
} as const;
